import { useEffect, useState } from "react";

const DURATION_MS = (17 * 60 + 34) * 1000;
let endAt = Date.now() + DURATION_MS;

function remaining(): number {
  let diff = endAt - Date.now();
  if (diff <= 0) {
    endAt = Date.now() + DURATION_MS;
    diff = DURATION_MS;
  }
  return diff;
}

/** Shared countdown that restarts automatically at 00:17:34 when it hits zero. */
export function useCountdown() {
  const [ms, setMs] = useState(remaining);

  useEffect(() => {
    const id = window.setInterval(() => setMs(remaining()), 250);
    return () => window.clearInterval(id);
  }, []);

  const total = Math.ceil(ms / 1000);
  return {
    hours: Math.floor(total / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}
